/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LaundryGroupLog } from './LaundryGroupLog';
import {
    LaundryGroupLogFromJSON,
    LaundryGroupLogFromJSONTyped,
    LaundryGroupLogToJSON,
} from './LaundryGroupLog';
import type { Page } from './Page';
import {
    PageFromJSON,
    PageFromJSONTyped,
    PageToJSON,
} from './Page';

/**
 * 
 * @export
 * @interface PageableLaundryGroupLogs
 */
export interface PageableLaundryGroupLogs {
    /**
     * 
     * @type {Array<LaundryGroupLog>}
     * @memberof PageableLaundryGroupLogs
     */
    result: Array<LaundryGroupLog>;
    /**
     * 
     * @type {Page}
     * @memberof PageableLaundryGroupLogs
     */
    page: Page;
}

/**
 * Check if a given object implements the PageableLaundryGroupLogs interface.
 */
export function instanceOfPageableLaundryGroupLogs(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "result" in value;
    isInstance = isInstance && "page" in value;

    return isInstance;
}

export function PageableLaundryGroupLogsFromJSON(json: any): PageableLaundryGroupLogs {
    return PageableLaundryGroupLogsFromJSONTyped(json, false);
}

export function PageableLaundryGroupLogsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageableLaundryGroupLogs {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'result': ((json['result'] as Array<any>).map(LaundryGroupLogFromJSON)),
        'page': PageFromJSON(json['page']),
    };
}

export function PageableLaundryGroupLogsToJSON(value?: PageableLaundryGroupLogs | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'result': ((value.result as Array<any>).map(LaundryGroupLogToJSON)),
        'page': PageToJSON(value.page),
    };
}

